export const CITIES = {
  palestine: [
    {
        "label": "Abasan al-Kabira",
        "value": "Abasan al-Kabira"
    },
    {
        "label": "Abu Dis",
        "value": "Abu Dis"
    },
    {
        "label": "Bani Na'im",
        "value": "Bani Na'im"
    },
    {
        "label": "Bani Suheila",
        "value": "Bani Suheila"
    },
    {
        "label": "Beit Hanoun",
        "value": "Beit Hanoun"
    },
    {
        "label": "Beit Jala",
        "value": "Beit Jala"
    },
    {
        "label": "Beit Lahia",
        "value": "Beit Lahia"
    },
    {
        "label": "Beit Sahour",
        "value": "Beit Sahour"
    },
    {
        "label": "Beit Ummar",
        "value": "Beit Ummar"
    },
    {
        "label": "Beitunia",
        "value": "Beitunia"
    },
    {
        "label": "Bethlehem",
        "value": "Bethlehem"
    },
    {
        "label": "al-Bireh",
        "value": "al-Bireh"
    },
    {
        "label": "Deir al-Balah",
        "value": "Deir al-Balah"
    },
    {
        "label": "ad-Dhahiriya",
        "value": "ad-Dhahiriya"
    },
    {
        "label": "Dura",
        "value": "Dura"
    },
    {
        "label": "Gaza City",
        "value": "Gaza City"
    },
    {
        "label": "Halhul",
        "value": "Halhul"
    },
    {
        "label": "Hebron",
        "value": "Hebron"
    },
    {
        "label": "Idhna",
        "value": "Idhna"
    },
    {
        "label": "Jabalia",
        "value": "Jabalia"
    },
    {
        "label": "Jenin",
        "value": "Jenin"
    },
    {
        "label": "Jericho",
        "value": "Jericho"
    },
    {
        "label": "Khan Yunis",
        "value": "Khan Yunis"
    },
    {
        "label": "Nablus",
        "value": "Nablus"
    },
    {
        "label": "Qabatiya",
        "value": "Qabatiya"
    },
    {
        "label": "Qalqilya",
        "value": "Qalqilya"
    },
    {
        "label": "Rafah",
        "value": "Rafah"
    },
    {
        "label": "Ramallah",
        "value": "Ramallah"
    },
    {
        "label": "Sa'ir",
        "value": "Sa'ir"
    },
    {
        "label": "Surif",
        "value": "Surif"
    },
    {
        "label": "Tubas",
        "value": "Tubas"
    },
    {
        "label": "Tulkarm",
        "value": "Tulkarm"
    },
    {
        "label": "Ya'bad",
        "value": "Ya'bad"
    },
    {
        "label": "al-Yamun",
        "value": "al-Yamun"
    },
    {
        "label": "Yatta",
        "value": "Yatta"
    },
    {
        "label": "az-Zawayda",
        "value": "az-Zawayda"
    }
    ],
    israel: [
        {
            "label": "Acre",
            "value": "Acre"
        },
        {
            "label": "Afula",
            "value": "Afula"
        },
        {
            "label": "Arad",
            "value": "Arad"
        },
        {
            "label": "Arraba",
            "value": "Arraba"
        },
        {
            "label": "Ashdod",
            "value": "Ashdod"
        },
        {
            "label": "Ashkelon",
            "value": "Ashkelon"
        },
        {
            "label": "Baqa al-Gharbiyye",
            "value": "Baqa al-Gharbiyye"
        },
        {
            "label": "Bat Yam",
            "value": "Bat Yam"
        },
        {
            "label": "Beersheba",
            "value": "Beersheba"
        },
        {
            "label": "Beit She'an",
            "value": "Beit She'an"
        },
        {
            "label": "Beit Shemesh",
            "value": "Beit Shemesh"
        },
        {
            "label": "Bnei Brak",
            "value": "Bnei Brak"
        },
        {
            "label": "Dimona",
            "value": "Dimona"
        },
        {
            "label": "Eilat",
            "value": "Eilat"
        },
        {
            "label": "El'ad",
            "value": "El'ad"
        },
        {
            "label": "Giv'at Shmuel",
            "value": "Giv'at Shmuel"
        },
        {
            "label": "Givatayim",
            "value": "Givatayim"
        },
        {
            "label": "Hadera",
            "value": "Hadera"
        },
        {
            "label": "Haifa",
            "value": "Haifa"
        },
        {
            "label": "Herzliya",
            "value": "Herzliya"
        },
        {
            "label": "Hod HaSharon",
            "value": "Hod HaSharon"
        },
        {
            "label": "Holon",
            "value": "Holon"
        },
        {
            "label": "Jerusalem",
            "value": "Jerusalem"
        },
        {
            "label": "Kafr Qasim",
            "value": "Kafr Qasim"
        },
        {
            "label": "Karmiel",
            "value": "Karmiel"
        },
        {
            "label": "Kfar Saba",
            "value": "Kfar Saba"
        },
        {
            "label": "Kfar Yona",
            "value": "Kfar Yona"
        },
        {
            "label": "Kiryat Ata",
            "value": "Kiryat Ata"
        },
        {
            "label": "Kiryat Bialik",
            "value": "Kiryat Bialik"
        },
        {
            "label": "Kiryat Gat",
            "value": "Kiryat Gat"
        },
        {
            "label": "Kiryat Malakhi",
            "value": "Kiryat Malakhi"
        },
        {
            "label": "Kiryat Motzkin",
            "value": "Kiryat Motzkin"
        },
        {
            "label": "Kiryat Ono",
            "value": "Kiryat Ono"
        },
        {
            "label": "Kiryat Shmona",
            "value": "Kiryat Shmona"
        },
        {
            "label": "Kiryat Yam",
            "value": "Kiryat Yam"
        },
        {
            "label": "Lod",
            "value": "Lod"
        },
        {
            "label": "Ma'alot-Tarshiha",
            "value": "Ma'alot-Tarshiha"
        },
        {
            "label": "Migdal HaEmek",
            "value": "Migdal HaEmek"
        },
        {
            "label": "Modi'in-Maccabim-Re'ut",
            "value": "Modi'in-Maccabim-Re'ut"
        },
        {
            "label": "Nahariya",
            "value": "Nahariya"
        },
        {
            "label": "Nazareth",
            "value": "Nazareth"
        },
        {
            "label": "Nesher",
            "value": "Nesher"
        },
        {
            "label": "Ness Ziona",
            "value": "Ness Ziona"
        },
        {
            "label": "Netanya",
            "value": "Netanya"
        },
        {
            "label": "Netivot",
            "value": "Netivot"
        },
        {
            "label": "Nof HaGalil",
            "value": "Nof HaGalil"
        },
        {
            "label": "Ofakim",
            "value": "Ofakim"
        },
        {
            "label": "Or Akiva",
            "value": "Or Akiva"
        },
        {
            "label": "Or Yehuda",
            "value": "Or Yehuda"
        },
        {
            "label": "Petah Tikva",
            "value": "Petah Tikva"
        },
        {
            "label": "Qalansawe",
            "value": "Qalansawe"
        },
        {
            "label": "Ra'anana",
            "value": "Ra'anana"
        },
        {
            "label": "Rahat",
            "value": "Rahat"
        },
        {
            "label": "Ramat Gan",
            "value": "Ramat Gan"
        },
        {
            "label": "Ramat HaSharon",
            "value": "Ramat HaSharon"
        },
        {
            "label": "Ramla",
            "value": "Ramla"
        },
        {
            "label": "Rehovot",
            "value": "Rehovot"
        },
        {
            "label": "Rishon LeZion",
            "value": "Rishon LeZion"
        },
        {
            "label": "Rosh HaAyin",
            "value": "Rosh HaAyin"
        },
        {
            "label": "Safed",
            "value": "Safed"
        },
        {
            "label": "Sakhnin",
            "value": "Sakhnin"
        },
        {
            "label": "Sderot",
            "value": "Sderot"
        },
        {
            "label": "Shefa-'Amr",
            "value": "Shefa-'Amr"
        },
        {
            "label": "Tamra",
            "value": "Tamra"
        },
        {
            "label": "Tayibe",
            "value": "Tayibe"
        },
        {
            "label": "Tel Aviv-Yafo",
            "value": "Tel Aviv-Yafo"
        },
        {
            "label": "Tiberias",
            "value": "Tiberias"
        },
        {
            "label": "Tira",
            "value": "Tira"
        },
        {
            "label": "Tirat Carmel",
            "value": "Tirat Carmel"
        },
        {
            "label": "Umm al-Fahm",
            "value": "Umm al-Fahm"
        },
        {
            "label": "Yavne",
            "value": "Yavne"
        },
        {
            "label": "Yehud-Monosson",
            "value": "Yehud-Monosson"
        },
        {
            "label": "Yokneam Illit",
            "value": "Yokneam Illit"
        }
    ],
};
